/* eslint-disable max-len */

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    name: 'YuriDatePicker',
    props: {
        type: {
            type: String
        },
        YuriPlaceholder: {
            type: String,
            default: 'DD/MM/AAAA'
        },
        isDisabled: {
            type: Boolean
        },
        startDate: {
            type: Object
        },
        dateSelected: {
            type: String
        },
        dateValue: {
            type: String
        },
        minValue: {
            type: Date
        },
        disabled: {
            type: Boolean,
            default: false
        },
        mustBeAdult: {
            type: Boolean,
            default: false
        },
        todayDisabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // Campos de opciones/configuración
            today: '',
            date: '',
            showTimePanel: false
        };
    },
    watch: {
        isDisabled(newValue) {
            if (newValue) {
                this.date = '';
            }
        },
        dateSelected(newValue) {
            if (!newValue) {
                this.date = '';
            }
        }
    },
    created() {
        if (this.dateValue) {
            if (this.type === 'date-time') {
                this.date = this.$moment(new Date(this.dateValue)).format('YYYY-MM-DD HH:mm:SS');
            } else if (this.type === 'range') {
                const dateRange = this.dateValue.split(' ');
                this.date = [this.$moment(new Date(dateRange[0])).format('YYYY-MM-DD'), this.$moment(new Date(dateRange[1])).format('YYYY-MM-DD')];
            } else if (this.type === 'operation') {
                const newMinAge = new Date(this.dateValue);
                newMinAge.setFullYear(newMinAge.getFullYear(), newMinAge.getMonth() - 1, newMinAge.getDate());
                this.dateMinAge = newMinAge;
                this.date = this.dateValue;
            } else {
                this.date = this.dateValue;
            }
        }

        if (this.dateSelected) {
            this.date = this.dateSelected;
        }
    },
    methods: {
        toggleTimePanel() {
            this.showTimePanel = !this.showTimePanel;
        },
        handleOpenChange() {
            this.showTimePanel = false;
        }
    },
    computed: {
        dateMinAge() {
            const minYears = this.mustBeAdult ? 18 : 0; // edad mínima en años
            const now = new Date();
            const today = this.todayDisabled ? new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1) : new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const minAge = new Date(today);
            minAge.setFullYear(minAge.getFullYear() - minYears);
            return minAge;
        },
        dateMaxAge() {
            const maxYears = 100; // 100 años como edad máxima
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            this.today = today;
            const maxAge = new Date(today);
            maxAge.setFullYear(maxAge.getFullYear() - maxYears);
            return maxAge;
        }

    }
};
